import React from 'react';
import { Skeleton } from '../../Skeleton';

const MedwikiRelatedPostLoader = ({ title }) => {
  return (
    <>
      <div
        className="w-100 medwikiRelatedBox bg-white rounded-3 shadow text-center p-3 p-md-4 mb-5"
        id="medwiki_related_post"
      >
        <Skeleton variant="text" width="30%" height="100%" />
        <div className="medwikiRelatedBoxIn">
          {[1, 2, 3, 4].map((i) => (
            <div className="d-flex justify-content-between align-items-center">
              <Skeleton variant="rounded" width={50} height={50} className="mt-3 me-2" />
              <div className="w-100">
                <Skeleton variant="text" width="50%" height="100%" />
                <Skeleton variant="text" width="90%" height="100%" />
                <Skeleton variant="text" width="30%" height="100%" />
              </div>
            </div>
          ))}
        </div>
        <Skeleton variant="rounded" width="100%" height={30} className="mt-3" />
      </div>
    </>
  );
};

export default MedwikiRelatedPostLoader;
